const fetchDatasources = async (workspace: string) => {
    // Validate workspace parameter
    if (!workspace) {
        console.warn('fetchDatasources service called without workspace ID');
        return [];
    }

    const response = await fetch('/api/datasources/list', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ workspace }),
    });

    if (!response.ok) {
        console.warn('fetchDatasources failed:', response.status, response.statusText);
        return [];
    }

    const responseJson = await response.json();
    return Array.isArray(responseJson) ? responseJson : [];
}

export const datasourcesService = { fetchDatasources }